export const emptyToUndefined = <T>(value: T[] | undefined): T[] | undefined =>
  value && value.length > 0 ? value : undefined;
